import { useCallback, useState, startTransition } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { preloadRouteForPath } from '@/utils/routePreload';

export function useFastNavigation() {
  const navigate = useNavigate();
  const [pendingPath, setPendingPath] = useState<string | null>(null);

  const prefetch = useCallback((path: string) => {
    preloadRouteForPath(path);
  }, []);

  const fastNavigate = useCallback((path: string, options?: NavigateOptions) => {
    setPendingPath(path);
    preloadRouteForPath(path);
    startTransition(() => navigate(path, options));
  }, [navigate]);

  return { fastNavigate, prefetch, pendingPath, isNavigating: pendingPath !== null };
}